enum ObstetricalFileType {
    QuebecForm,
    OntarioForm,
    BritishColumbiaForm
}

export { ObstetricalFileType };
